import { render, staticRenderFns } from "./DispatchMed.vue?vue&type=template&id=0214f752&scoped=true"
import script from "./DispatchMed.vue?vue&type=script&lang=js"
export * from "./DispatchMed.vue?vue&type=script&lang=js"
import style0 from "./DispatchMed.vue?vue&type=style&index=0&id=0214f752&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214f752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0214f752')) {
      api.createRecord('0214f752', component.options)
    } else {
      api.reload('0214f752', component.options)
    }
    module.hot.accept("./DispatchMed.vue?vue&type=template&id=0214f752&scoped=true", function () {
      api.rerender('0214f752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/DispatchMed.vue"
export default component.exports